import React from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import CDInput from 'components/cd-input'
import TextArea from 'components/text-area'
import CDImage from 'components/cd-image-upload'
import CDButton from 'components/cd-button'
import NativeSelect from '../components/native-select'
import { bannersApi } from '../restaurant.api'
import { useBanners } from './banners.context'

const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
]

const validationSchema = Yup.object({
  title: Yup.string().required('Title is required'),
  image: Yup.string().required('Banner image is required'),
})

const toInitialValues = (banner) => ({
  title: banner?.title || '',
  subtitle: banner?.subtitle || '',
  badge: banner?.badge || '',
  buttonText: banner?.buttonText || 'Order Now',
  buttonUrl: banner?.buttonUrl || '#menu',
  status: banner?.status || 'active',
  image: banner?.image || '',
})

function BannerForm({ banner, onClose }) {
  const { refresh } = useBanners()
  const isEditing = !!banner?._id

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = { ...values }
    delete payload.imageName // set by cd-image-upload, not part of the model

    const { response } = isEditing
      ? await bannersApi.update(banner._id, payload)
      : await bannersApi.create(payload)

    setSubmitting(false)
    if (response?.success) {
      await refresh()
      onClose()
    }
  }

  return (
    <Formik
      initialValues={toInitialValues(banner)}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formik) => (
        <Form className='tw-flex tw-flex-col tw-gap-4'>
          <CDInput name='title' label='Title' required />
          <TextArea name='subtitle' label='Subtitle' />
          <CDInput name='badge' label='Badge' />
          <div className='tw-flex tw-gap-4'>
            <CDInput name='buttonText' label='Button text' />
            <CDInput name='buttonUrl' label='Button URL' />
          </div>
          <NativeSelect name='status' label='Status' options={STATUS_OPTIONS} />
          <CDImage name='image' label='Banner image' />

          <div className='tw-flex tw-gap-3 tw-mt-2'>
            <CDButton
              type='submit'
              processing={formik.isSubmitting}
              label={isEditing ? 'Save changes' : 'Create banner'}
            />
            <button
              type='button'
              onClick={onClose}
              className='tw-px-[24px] tw-py-[8px] tw-rounded-[6px] tw-border tw-border-gray-300 tw-text-gray-600 tw-text-regular'
            >
              Cancel
            </button>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default BannerForm
